// https://www.npmjs.com/package/react-redux-i18n
export const defaultLanguage = 'en';

export const listLanguage = {
  en: 'en',
  vi: 'vi',
};
